export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full">
                <i className="ri-home-heart-line text-2xl"></i>
              </div>
              <div>
                <div className="text-xl font-bold">ぽかぽか堂</div>
                <div className="text-sm opacity-90">よりみち相談室</div>
              </div>
            </div>
            <p className="text-sm opacity-90 leading-relaxed">
              お客様のビジネスの成長を<br />
              デジタルの力でサポートします
            </p>
          </div>

          <div className="space-y-3">
            <h4 className="text-lg font-bold">サービス</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li><a href="/" className="hover:underline cursor-pointer whitespace-nowrap">個人向けサポート</a></li>
              <li><a href="/business" className="hover:underline cursor-pointer whitespace-nowrap">企業向け制作サービス</a></li>
              <li><a href="/#workshop" className="hover:underline cursor-pointer whitespace-nowrap">Canva講座</a></li>
            </ul>
          </div>

          <div className="space-y-3">
            <h4 className="text-lg font-bold">お問い合わせ</h4>
            <ul className="space-y-2 text-sm opacity-90">
              <li>
                <a href="tel:08034796908" className="hover:underline cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line mr-2"></i>080-3479-6908
                </a>
              </li>
              <li>
                <a href="mailto:nao6091970@gmail.com" className="hover:underline cursor-pointer break-all">
                  <i className="ri-mail-line mr-2"></i>nao6091970@gmail.com
                </a>
              </li>
              <li className="opacity-90">
                埼玉県北葛飾郡松伏町松伏1-9-9-6
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center">
          <p className="text-sm opacity-90">
            © 2024 ぽかぽか堂 よりみち相談室. All rights reserved. | 
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:underline ml-2 cursor-pointer whitespace-nowrap">
              Powered by Readdy
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
